import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Ingredient } from '../types/ingredient';

export const getIngredientByName = async (ingredientName: string): Promise<Ingredient | null> => {
  try {
    const docRef = doc(db, 'Ingredients', ingredientName);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data()
      } as Ingredient;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching ingredient:', error);
    throw error;
  }
};
